import axiosInstance from "../../axiosInstance";
import { normalizeApiError } from "../../../utils/normalizeApiError";


export interface DeleteProjectResponce{
    status:boolean;
    message:string;
}
export interface DeleteProjectAPIResponce{
    response:DeleteProjectResponce
}

export const deleteProject= async (
    projectUuid:string
):Promise<DeleteProjectResponce>=>{
    try {
        const {data}=await axiosInstance.delete<DeleteProjectAPIResponce>(`/pmo/delete-project/${projectUuid}`);
        return data.response;   
        
    } catch (error) {
        throw normalizeApiError(error);        
    }

}